import { ArrowLeftOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Spin, Typography } from 'antd';
import { FC } from 'react';

export interface IDonorDetailsHeaderProps {
  title: string;
  description: string;
  iconColor: string;
  donorCount: number;
  countLabel?: string;
  loading?: boolean;
  onBack?: () => void;
  onLoadActiveDonors?: () => void;
}

const { Title, Text } = Typography;

const DonorDetailsHeader: FC<IDonorDetailsHeaderProps> = ({
  title,
  description,
  iconColor,
  donorCount,
  countLabel = 'donors',
  loading,
  onBack,
  onLoadActiveDonors,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 12,
        marginBottom: 20,
        padding: '16px 20px',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecef 100%)',
        borderRadius: 8,
        border: `2px solid ${iconColor}30`,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 8,
          background: `${iconColor}20`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <TableOutlined style={{ fontSize: 24, color: iconColor }} />
      </div>
      <div style={{ flex: '1 1 200px', minWidth: 0 }}>
        <Title level={4} style={{ margin: 0, color: '#2f3a45' }}>
          {title}
        </Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {description}
        </Text>
        <div style={{ marginTop: 4 }}>
          {loading ? (
            <Spin size="small" />
          ) : (
            <Text strong style={{ color: iconColor }}>
              {donorCount.toLocaleString()} {countLabel}
            </Text>
          )}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          gap: 8,
          flexWrap: 'wrap',
          marginLeft: 'auto',
        }}
      >
        {onLoadActiveDonors && (
          <Button
            type="default"
            icon={<TableOutlined />}
            onClick={onLoadActiveDonors}
          >
            Load Active Donors
          </Button>
        )}
        {onBack && (
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            style={{
              background: '#0b345f',
              borderColor: '#0b345f',
              color: '#fff',
            }}
          >
            Back to Dashboard
          </Button>
        )}
      </div>
    </div>
  );
};

export default DonorDetailsHeader;
